import API from 'config/api'
import { appRoutes } from 'config/routes'
import LoadingSpinner from 'deprecated/atoms/spinner'
import Login from 'organisms/login'
import EmailLogin from 'organisms/login/emailLogin'
import LoginForm from 'organisms/login/loginForm'
import SessionExpired from 'organisms/login/sessionExpired'
import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router-dom'
import axios from 'utils/axios'
import { initializeLogin, updateFormValues } from '../../actions'

export interface LoginContainerProps {}

const LoginContainer = (props): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const {
    location: { search, pathname },
    user
  } = props

  const submitLoginForm = async (
    e: React.FormEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>
  ) => {
    const {
      user: {
        login: {
          fields: { email }
        }
      }
    } = props

    if (e && e.preventDefault) {
      e.preventDefault()
    }

    setIsLoading(true)

    const res = await axios.put(`${API.loginLinks}`, {
      email: email.value
    })

    setIsLoading(false)

    setSubmitted(true)
  }

  const updateFormValues = (form: string) => (
    e: React.FormEvent<HTMLInputElement>
  ): void => {
    props.updateFormValues(
      {
        type: e.currentTarget.name,
        value: e.currentTarget.value
      },
      form
    )
  }

  const {
    user: { login }
  } = props

  return (
    <Login>
      {isLoading && <LoadingSpinner size="small" />}
      <Route
        exact
        path={appRoutes.login}
        render={props => (
          <LoginForm
            history={props.history}
            valid={login.valid}
            onSubmit={submitLoginForm}
            onChange={updateFormValues('login')}
            errorMessage={login.errorMessage}
            submitted={submitted}
            setSubmitted={setSubmitted}
            form={{
              email: login.fields.email.value
            }}
          />
        )}
      />
      <Route
        // exact
        path={appRoutes.emailLogin}
        render={props => <EmailLogin />}
      />

      <Route path="/login/sessionExpired" component={SessionExpired} />
    </Login>
  )
}

const mapStateToProps = state => ({
  user: state.userState.user
})

const mapDispatchToProps = dispatch => ({
  initializeUserLogin: () => dispatch(initializeLogin()),

  updateFormValues: ({ type, value }, form) =>
    dispatch(updateFormValues({ type, value }, form))
})

export const TestLoginContainer = LoginContainer

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
)
